import { TenantEntity } from '../TenantEntity'

export class Charge extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'Charge'
  }

  get isDirty() {
    return this._data.isDirty
  }
  set isDirty(isDirty) {
    this._data.dirty = isDirty
  }

  get chargeId() {
    return this._data.chargeId
  }
  set chargeId(chargeId) {
    this._data.chargeId = chargeId || 0
  }
  get chargeItemId() {
    return this._data.chargeItemId
  }
  set chargeItemId(chargeItemId) {
    this._data.chargeItemId = chargeItemId || 0
  }
  get receivable() {
    return this._data.receivable
  }
  set receivable(receivable) {
    this._data.receivable = receivable || false
  }
  get oversea() {
    return this._data.oversea
  }
  set oversea(oversea) {
    this._data.oversea = oversea || false
  }
  get adjustment() {
    return this._data.adjustment
  }
  set adjustment(adjustment) {
    this._data.adjustment = adjustment || false
  }
  get shared() {
    return this._data.shared
  }
  set shared(shared) {
    this._data.shared = shared || false
  }
  get shareScheme() {
    return this._data.shareScheme
  }
  set shareScheme(shareScheme) {
    this._data.shareScheme = shareScheme || 0
  }
  get shareRefNo() {
    return this._data.shareRefNo
  }
  set shareRefNo(shareRefNo) {
    this._data.shareRefNo = shareRefNo
  }
  get commission() {
    return this._data.commission
  }
  set commission(commission) {
    this._data.commission = commission || false
  }
  get advance() {
    return this._data.advance
  }
  set advance(advance) {
    this._data.advance = advance || false
  }
  get prepaid() {
    return this._data.prepaid
  }
  set prepaid(prepaid) {
    this._data.prepaid = prepaid || false
  }
  get paidOff() {
    return this._data.paidOff
  }
  set paidOff(paidOff) {
    this._data.paidOff = paidOff || false
  }
  get collection() {
    return this._data.collection
  }
  set collection(collection) {
    this._data.collection = collection || false
  }
  get relatedId() {
    return this._data.relatedId
  }
  set relatedId(relatedId) {
    this._data.relatedId = relatedId || 0
  }
  get accountId() {
    return this._data.accountId
  }
  set accountId(accountId) {
    this._data.accountId = accountId || 0
  }
  get invoiceTitle() {
    return this._data.invoiceTitle
  }
  set invoiceTitle(invoiceTitle) {
    this._data.invoiceTitle = invoiceTitle
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get measure() {
    return this._data.measure
  }
  set measure(measure) {
    this._data.measure = measure
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get unitRate() {
    return this._data.unitRate
  }
  set unitRate(unitRate) {
    this._data.unitRate = unitRate || 0
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0
  }
  get verifiedAmount() {
    return this._data.verifiedAmount
  }
  set verifiedAmount(verifiedAmount) {
    this._data.verifiedAmount = verifiedAmount || 0
  }
  get exchangeRate() {
    return this._data.exchangeRate
  }
  set exchangeRate(exchangeRate) {
    this._data.exchangeRate = exchangeRate || 0
  }
  get billNo() {
    return this._data.billNo
  }
  set billNo(billNo) {
    this._data.billNo = billNo
  }
  get counterPartyBillingNo() {
    return this._data.counterPartyBillingNo
  }
  set counterPartyBillingNo(counterPartyBillingNo) {
    this._data.counterPartyBillingNo = counterPartyBillingNo
  }
  get paymentNo() {
    return this._data.paymentNo
  }
  set paymentNo(paymentNo) {
    this._data.paymentNo = paymentNo
  }
  get invoiceNo() {
    return this._data.invoiceNo
  }
  set invoiceNo(invoiceNo) {
    this._data.invoiceNo = invoiceNo
  }
  get voucherNo() {
    return this._data.voucherNo
  }
  set voucherNo(voucherNo) {
    this._data.voucherNo = voucherNo
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy || 0
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get auditor() {
    return this._data.auditor
  }
  set auditor(auditor) {
    this._data.auditor = auditor || 0
  }
  get auditDate() {
    return this._data.auditDate
  }
  set auditDate(auditDate) {
    this._data.auditDate = auditDate
  }
  get accountingDate() {
    return this._data.accountingDate
  }
  set accountingDate(accountingDate) {
    this._data.accountingDate = accountingDate
  }
  get clearingDate() {
    return this._data.clearingDate
  }
  set clearingDate(clearingDate) {
    this._data.clearingDate = clearingDate
  }
  get payReceiveDate() {
    return this._data.payReceiveDate
  }
  set payReceiveDate(payReceiveDate) {
    this._data.payReceiveDate = payReceiveDate
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get inputByDep() {
    return this._data.inputByDep
  }
  set inputByDep(inputByDep) {
    this._data.inputByDep = inputByDep || 0
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get taxRate() {
    return this._data.taxRate
  }
  set taxRate(taxRate) {
    this._data.taxRate = taxRate || 0
  }
  get taxAmount() {
    return this._data.taxAmount
  }
  set taxAmount(taxAmount) {
    this._data.taxAmount = taxAmount || 0
  }
  get excludingTaxAmount() {
    return this._data.excludingTaxAmount
  }
  set excludingTaxAmount(excludingTaxAmount) {
    this._data.excludingTaxAmount = excludingTaxAmount || 0
  }
  get controlled() {
    return this._data.controlled
  }
  set controlled(controlled) {
    this._data.controlled = controlled || false
  }
  get chargeSource() {
    return this._data.chargeSource
  }
  set chargeSource(chargeSource) {
    this._data.chargeSource = chargeSource || 0
  }
  get chargeState() {
    return this._data.chargeState
  }
  set chargeState(chargeState) {
    this._data.chargeState = chargeState || 0
  }
  get confirmState() {
    return this._data.confirmState
  }
  set confirmState(confirmState) {
    this._data.confirmState = confirmState || 0
  }
  get confirmDate() {
    return this._data.confirmDate
  }
  set confirmDate(confirmDate) {
    this._data.confirmDate = confirmDate
  }
  get confirmUser() {
    return this._data.confirmUser
  }
  set confirmUser(confirmUser) {
    this._data.confirmUser = confirmUser || 0
  }
  get billingAmount() {
    return this._data.billingAmount
  }
  set billingAmount(billingAmount) {
    this._data.billingAmount = billingAmount || 0
  }
  get confirmRemarks() {
    return this._data.confirmRemarks
  }
  set confirmRemarks(confirmRemarks) {
    this._data.confirmRemarks = confirmRemarks
  }
  get differentState() {
    return this._data.differentState
  }
  set differentState(differentState) {
    this._data.differentState = differentState || 0
  }
  get invoiceAmount() {
    return this._data.invoiceAmount
  }
  set invoiceAmount(invoiceAmount) {
    this._data.invoiceAmount = invoiceAmount || 0
  }
  get invoiceExcludingTax() {
    return this._data.invoiceExcludingTax
  }
  set invoiceExcludingTax(invoiceExcludingTax) {
    this._data.invoiceExcludingTax = invoiceExcludingTax || 0
  }
  get invoiceTax() {
    return this._data.invoiceTax
  }
  set invoiceTax(invoiceTax) {
    this._data.invoiceTax = invoiceTax || 0
  }
  get offsetState() {
    return this._data.offsetState
  }
  set offsetState(offsetState) {
    this._data.offsetState = offsetState || 0
  }
  get serviceType() {
    return this._data.serviceType
  }
  set serviceType(serviceType) {
    this._data.serviceType = serviceType || 0
  }
  get contactPerson() {
    return this._data.contactPerson
  }
  set contactPerson(contactPerson) {
    this._data.contactPerson = contactPerson
  }
  get payable() {
    return this._data.payable
  }
  set payable(payable) {
    this._data.payable = payable || false
  }
  get ppcc() {
    return this._data.ppcc
  }
  set ppcc(ppcc) {
    this._data.ppcc = ppcc
  }
  get relatedMbl() {
    return this._data.relatedMbl
  }
  set relatedMbl(relatedMbl) {
    this._data.relatedMbl = relatedMbl
  }
  get needInvoice() {
    return this._data.needInvoice
  }
  set needInvoice(needInvoice) {
    this._data.needInvoice = needInvoice || true
  }
  get paymentCompany() {
    return this._data.paymentCompany
  }
  set paymentCompany(paymentCompany) {
    this._data.paymentCompany = paymentCompany
  }
  get serialNumber() {
    return this._data.serialNumber
  }
  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber || 0
  }
  get billingDate() {
    return this._data.billingDate
  }
  set billingDate(billingDate) {
    this._data.billingDate = billingDate
  }
  get invoiceDate() {
    return this._data.invoiceDate
  }
  set invoiceDate(invoiceDate) {
    this._data.invoiceDate = invoiceDate
  }
  get businessDate() {
    return this._data.businessDate
  }
  set businessDate(businessDate) {
    this._data.businessDate = businessDate
  }
  get voucherJob() {
    return this._data.voucherJob
  }
  set voucherJob(voucherJob) {
    this._data.voucherJob = voucherJob || false
  }
  get voucherBilling() {
    return this._data.voucherBilling
  }
  set voucherBilling(voucherBilling) {
    this._data.voucherBilling = voucherBilling || false
  }
  get voucherInvoice() {
    return this._data.voucherInvoice
  }
  set voucherInvoice(voucherInvoice) {
    this._data.voucherInvoice = voucherInvoice || false
  }
  get provisionedDate() {
    return this._data.provisionedDate
  }
  set provisionedDate(provisionedDate) {
    this._data.provisionedDate = provisionedDate
  }
  get closingAccountExcludingTax() {
    return this._data.closingAccountExcludingTax
  }
  set closingAccountExcludingTax(closingAccountExcludingTax) {
    this._data.closingAccountExcludingTax = closingAccountExcludingTax || 0
  }
  get closingAccountTax() {
    return this._data.closingAccountTax
  }
  set closingAccountTax(closingAccountTax) {
    this._data.closingAccountTax = closingAccountTax || 0
  }
  get splitRelationKey() {
    return this._data.splitRelationKey
  }
  set splitRelationKey(splitRelationKey) {
    this._data.splitRelationKey = splitRelationKey
  }
  get special() {
    return this._data.special
  }
  set special(special) {
    this._data.special = special || false
  }
  get voucherDate() {
    return this._data.voucherDate
  }
  set voucherDate(voucherDate) {
    this._data.voucherDate = voucherDate
  }
  get truckOrderNo() {
    return this._data.truckOrderNo
  }
  set truckOrderNo(truckOrderNo) {
    this._data.truckOrderNo = truckOrderNo
  }
  get targetVoucherNo() {
    return this._data.targetVoucherNo
  }
  set targetVoucherNo(targetVoucherNo) {
    this._data.targetVoucherNo = targetVoucherNo
  }
  get billingUuid() {
    return this._data.billingUuid
  }
  set billingUuid(billingUuid) {
    this._data.billingUuid = billingUuid
  }
  get invoiceUuid() {
    return this._data.invoiceUuid
  }
  set invoiceUuid(invoiceUuid) {
    this._data.invoiceUuid = invoiceUuid
  }
  get billingPaymentUuid() {
    return this._data.billingPaymentUuid
  }
  set billingPaymentUuid(billingPaymentUuid) {
    this._data.billingPaymentUuid = billingPaymentUuid
  }
  get confirmBillUuid() {
    return this._data.confirmBillUuid
  }
  set confirmBillUuid(confirmBillUuid) {
    this._data.confirmBillUuid = confirmBillUuid
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get diffChargeUuid() {
    return this._data.diffChargeUuid
  }
  set diffChargeUuid(diffChargeUuid) {
    this._data.diffChargeUuid = diffChargeUuid
  }
  get agentSharedBillingUuid() {
    return this._data.agentSharedBillingUuid
  }
  set agentSharedBillingUuid(agentSharedBillingUuid) {
    this._data.agentSharedBillingUuid = agentSharedBillingUuid
  }

  // 以下是扩展属性
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }

  get sourceAmount() {
    return this._data.sourceAmount
  }
  set sourceAmount(sourceAmount) {
    this._data.sourceAmount = sourceAmount || 0
  }

  get chargeUpdate() {
    return this._data.chargeUpdatefice
  }
  set chargeUpdate(chargeUpdate) {
    this._data.chargeUpdate = chargeUpdate || false
  }

  get sapStatus() {
    return this._data.sapStatus
  }
  set sapStatus(sapStatus) {
    this._data.sapStatus = sapStatus
  }

  get partnerType() {
    return this._data.partnerType
  }
  set partnerType(partnerType) {
    this._data.partnerType = partnerType
  }
  get unitPriceIncludeTax() {
    return this._data.unitPriceIncludeTax
  }
  set unitPriceIncludeTax(unitPriceIncludeTax) {
    this._data.unitPriceIncludeTax = unitPriceIncludeTax
  }
  get changer() {
    return this._data.changer
  }
  set changer(changer) {
    this._data.changer = changer || 0
  }
  get settlementAgentId() {
    return this._data.settlementAgentId
  }
  set settlementAgentId(settlementAgentId) {
    this._data.settlementAgentId = settlementAgentId || 0
  }
  get syncStatus() {
    return this._data.syncStatus
  }
  set syncStatus(syncStatus) {
    this._data.syncStatus = syncStatus || 0
  }
  get syncConfirmStatus() {
    return this._data.syncConfirmStatus
  }
  set syncConfirmStatus(syncConfirmStatus) {
    this._data.syncConfirmStatus = syncConfirmStatus || 0
  }
  // 费用状态(第三方)
  get externalChargeState() {
    return this._data.externalChargeState
  }
  set externalChargeState(externalChargeState) {
    this._data.externalChargeState = externalChargeState || 0
  }
  // 推送批次号(第三方)
  get externalSerialNumber() {
    return this._data.externalSerialNumber
  }
  set externalSerialNumber(externalSerialNumber) {
    this._data.externalSerialNumber = externalSerialNumber
  }
  // 实际收付金额(第三方)
  get arPaymentAmount() {
    return this._data.arPaymentAmount
  }
  set arPaymentAmount(arPaymentAmount) {
    this._data.arPaymentAmount = arPaymentAmount || 0
  }
  // 费用确认批次
  get confirmSerialNumber() {
    return this._data.confirmSerialNumber
  }
  set confirmSerialNumber(confirmSerialNumber) {
    this._data.confirmSerialNumber = confirmSerialNumber
  }
  // 费用到期日
  get dueDate() {
    return this._data.dueDate
  }
  set dueDate(dueDate) {
    this._data.dueDate = dueDate
  }
  // 是否需要计算费用到期日
  get dueDirtyDate() {
    return this._data.dueDirtyDate
  }
  set dueDirtyDate(dueDirtyDate) {
    this._data.dueDirtyDate = dueDirtyDate
  }
  // 提成金额
  get commissionAmount() {
    return this._data.commissionAmount
  }
  set commissionAmount(commissionAmount) {
    this._data.commissionAmount = commissionAmount || 0
  }
  // 是否内结
  get internal() {
    return this._data.internal
  }
  set internal(internal) {
    this._data.internal = internal || false
  }
  // 协作分公司费用ID
  get internalTo() {
    return this._data.internalTo
  }
  set internalTo(internalTo) {
    this._data.internalTo = internalTo || 0
  }
  // 接单分公司费用ID
  get internalFrom() {
    return this._data.internalFrom
  }
  set internalFrom(internalFrom) {
    this._data.internalFrom = internalFrom || 0
  }
  get jdyxkSyncStatus() {
    return this._data.jdyxkSyncStatus
  }
  set jdyxkSyncStatus(jdyxkSyncStatus) {
    this._data.jdyxkSyncStatus = jdyxkSyncStatus || 0
  }
  get jdyxkSyncFailReason() {
    return this._data.jdyxkSyncFailReason
  }
  set jdyxkSyncFailReason(jdyxkSyncFailReason) {
    this._data.jdyxkSyncFailReason = jdyxkSyncFailReason
  }
  get whtTaxRate() {
    return this._data.whtTaxRate
  }
  set whtTaxRate(whtTaxRate) {
    this._data.whtTaxRate = whtTaxRate || 0
  }
  get whtTaxAmount() {
    return this._data.whtTaxAmount
  }
  set whtTaxAmount(whtTaxAmount) {
    this._data.whtTaxAmount = whtTaxAmount || 0
  }
  get whtTaxLocalAmount() {
    return this._data.whtTaxLocalAmount
  }
  set whtTaxLocalAmount(whtTaxLocalAmount) {
    this._data.whtTaxLocalAmount = whtTaxLocalAmount || 0
  }
  get commitUser() {
    return this._data.commitUser
  }
  set commitUser(commitUser) {
    this._data.commitUser = commitUser || 0
  }
  get commitDate() {
    return this._data.commitDate
  }
  set commitDate(commitDate) {
    this._data.commitDate = commitDate
  }
  get costControlType() {
    return this._data.costControlType
  }
  set costControlType(costControlType) {
    this._data.costControlType = costControlType
  }
  get autoGenerated() {
    return this._data.autoGenerated
  }
  set autoGenerated(autoGenerated) {
    this._data.autoGenerated = autoGenerated
  }
  get businessQuotationAmount() {
    return this._data.businessQuotationAmount
  }
  set businessQuotationAmount(businessQuotationAmount) {
    this._data.businessQuotationAmount = businessQuotationAmount
  }
  get businessQuotationConfirmd() {
    return this._data.businessQuotationConfirmd
  }
  set businessQuotationConfirmd(businessQuotationConfirmd) {
    this._data.businessQuotationConfirmd = businessQuotationConfirmd
  }
}
